import React, { useEffect, useState } from 'react';
import './GeoShippingNotice.css';

const STORAGE_KEY = 'javiland_geo_notice_dismissed';

/**
 * Aviso para visitantes fuera de Colombia.
 * Solo se muestra una vez por sesión si la IP no es colombiana.
 */
const GeoShippingNotice = () => {
  const [visible, setVisible] = useState(false);
  const [countryName, setCountryName] = useState('');

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY) === '1') return;

    const check = async () => {
      try {
        const res = await fetch('https://ipapi.co/json/');
        if (!res.ok) return;
        const data = await res.json();
        const code = (data.country_code || '').toUpperCase();
        if (code && code !== 'CO') {
          setCountryName(data.country_name || 'tu país');
          setVisible(true);
        }
      } catch {
        /* Si falla la detección, no bloqueamos la experiencia */
      }
    };

    check();
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="geo-notice-overlay" role="dialog" aria-modal="true" aria-labelledby="geo-notice-title">
      <div className="geo-notice-card">
        <button type="button" className="geo-notice-close" onClick={dismiss} aria-label="Cerrar">
          <i className="fas fa-times" aria-hidden="true" />
        </button>

        <div className="geo-notice-flag" aria-hidden="true">
          <span className="geo-notice-flag-co">🇨🇴</span>
        </div>

        <h2 id="geo-notice-title" className="geo-notice-title">
          Por ahora solo enviamos a Colombia
        </h2>

        <p className="geo-notice-body">
          Detectamos que estás navegando desde
          {countryName ? ` ${countryName}` : ' fuera de Colombia'}.
          {' '}Nuestra tienda opera envíos dentro de Colombia. Puedes explorar el catálogo,
          pero el checkout estará disponible solo para direcciones colombianas.
        </p>

        <p className="geo-notice-hint">
          ¿Estás en Colombia? Puede ser tu conexión VPN o red móvil. Igual puedes seguir explorando.
        </p>

        <button type="button" className="geo-notice-cta" onClick={dismiss}>
          Entendido, explorar Javiland
        </button>
      </div>
    </div>
  );
};

export default GeoShippingNotice;
